<template>
  <div>
    <v-card class="">
      <v-card-title> Checksum </v-card-title>
      <v-card-text class="d-flex flex-column">
        <v-form ref="form">
          <v-text-field
            outlined
            dense
            :label="'Paste your checksum value here (MD5)'"
            v-model="result.checksum"
          ></v-text-field>
          <div v-if="show_error">
            <small style="color: red"
              >Checksum invalid, it is not the same file
            </small>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="secondary"
          @click="$emit('submit', false)"
          depressed
          large
        >
          {{ $t("cancel") }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="checksum" depressed large> Check </v-btn>
      </v-card-actions>
    </v-card>

    <!-- <v-snackbar v-model="snackbar" :timeout="2000" :color="snackbar_color" top>
      {{ snackbar_text }}
    </v-snackbar> -->
  </div>
</template>

<script>
import { ref } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";

export default {
  name: "ChecksumDialog",
  props: {
    sectionId: String,
  },
  setup(props, { root, emit }) {
    const result = ref({
      section_id: props.sectionId,
      checksum: "",
    });
    const show_error = ref(false);
    const section_excel_md5 = ref("");
    const snackbar = ref(false);
    const snackbar_text = ref("");
    const snackbar_color = ref("green");

    const checksum = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/section/rbu_excel_checksum/",
        params: {
          ...result.value,
        },
      });

      let show_error = true;
      if (response.body.success) {
        section_excel_md5.value = response.body.section_checksum;

        if (response.body.valid) {
          root.$store.dispatch(ACTION_TYPES.SHOW_SNACKBAR, {
            message: "Checksum valid, it is the same file",
            color: "green",
            icon: "mdi mdi-check-circle",
          });
          //   snackbar_text.value = "Checksum valid, it is the same file";
          //   snackbar_color.value = "green";
          //   snackbar.value = true;
          show_error = false;
        }
      }

      if (show_error) {
        root.$store.dispatch(ACTION_TYPES.SHOW_SNACKBAR, {
          message: "Checksum invalid, it is not the same file",
          color: "#EF6363",
          icon: "mdi mdi-close-circle",
        });
        // snackbar_text.value = "Checksum invalid, it is not the same file";
        // snackbar_color.value = "red";
        // snackbar.value = true;
      }

      emit("submit", show_error);
    };

    return {
      checksum,
      result,
      show_error,
      section_excel_md5,
      snackbar,
      snackbar_text,
      snackbar_color,
    };
  },
};
</script>
